/**
 * Convert a date string of format dd-MM-yyyy to a Date object
 * Example: 2024-10-16 -> Date object
 * @param date
 */
export const dateStringToDateJS = (date: string) => {
  return new Date(date.replace(/-/g, '/'));
};

// convert format 17-07-2025 to date
export const dateInputToDateJS = (date: string) => {
  const [day, month, year] = date.split('-');
  return new Date(`${year}-${month}-${day}`);
};

/**
 * Formats a Date object into a string (DD-MM-YYYY).
 * @param date The Date object to format.
 * @returns The formatted date string.
 */
export const dateToDateString = (date: Date) => {
  return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
};

/**
 * Formats a Date object into a string (DD-MM-YYYY).
 * @param date The Date object to format.
 * @returns The formatted date string.
 */
export const dateToDateStringDateInput = (date: Date) => {
  return `${date.getFullYear().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate()}`;
};

/**
 * Formats a Date object into a string (YYYY-MM-DD).
 * @param date The Date object to format.
 * @returns The formatted date string.
 */
export const dateToDateStringISO = (date: Date) => {
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
};
